// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"DevComponents_buttonContainer__3IDTj","background":"DevComponents_background__1egxE","avatarContainer":"DevComponents_avatarContainer__LoypO"};